var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.2 7.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 4.1h2a.65.65 0 0 1 .6.6v2a.5.5 0 1 0 1 0v-2a.65.65 0 0 1 .6-.6h2a.5.5 0 1 0 0-1h-2a.65.65 0 0 1-.6-.6v-2a.5.5 0 1 0-1 0v2a.65.65 0 0 1-.6.6h-2a.5.5 0 0 0 0 1"
  })));
};
export default SvgPlus;